import {
  HUBBELL_FEEDBACK_DIVISIONS,
  type FeedbackSupplier,
} from "./hubbell-feedback.contract";

const words = (value: string): string =>
  value
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, " ")
    .trim();

/** A Division by tab letter as written (W. Ontario's is `+`), or by code or name. */
export function exceptionDivision(value: string) {
  const key = words(value);
  const letter = value.trim().toUpperCase();
  return HUBBELL_FEEDBACK_DIVISIONS.find(
    (division) =>
      division.letter === letter ||
      (key !== "" &&
        [division.code, division.name].some((name) => words(name) === key)),
  );
}

/** Filenames may name a supplier and a Division by code or business name. Row filters still narrow the match. */
export function exceptionFileScope(fileName: string) {
  const tokens = ` ${words(fileName.replace(/\.xlsx$/i, ""))} `;
  const suppliers: FeedbackSupplier[] = [];
  if (/\b(HUB|HUBBELL)\b/.test(tokens)) suppliers.push("hubbell");
  if (/\bABB\b/.test(tokens)) suppliers.push("abb");
  const divisions = HUBBELL_FEEDBACK_DIVISIONS.filter((division) =>
    [division.code, division.name].some((name) =>
      tokens.includes(` ${words(name)} `),
    ),
  );
  return {
    supplier: suppliers[0],
    division: divisions[0],
    ambiguous: suppliers.length > 1 || divisions.length > 1,
  };
}
